import { render, staticRenderFns } from "./TemplatesLabels.vue?vue&type=template&id=c8d58a6a&scoped=true&"
import script from "./TemplatesLabels.vue?vue&type=script&lang=js&"
export * from "./TemplatesLabels.vue?vue&type=script&lang=js&"
import style0 from "./TemplatesLabels.vue?vue&type=style&index=0&id=c8d58a6a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8d58a6a",
  null
  
)

export default component.exports